require("./bootstrap");
import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
import { ServerTable } from "v-tables-3";
require("./util/transHelper");
import NProgress from "nprogress";
import { Inertia } from "@inertiajs/inertia";

var vueTablesOptions = {
    perPage: 10,

    pagination: {
        chunk: 5,
    },

    sortIcon: {
        base: "",
        is: "sort-desc",
        up: "sort-asc",
        down: "sort-desc",
    },
};

function trans(string, args = {}) {
    let value = Object.byString(this.$page.props.localization, string);

    for (var key in args) {
        value = value.replace(`:${key}`, args[key]);
    }

    return value;
}

const appName =
    window.document.getElementsByTagName("title")[0]?.innerText ||
    "Fair Mieten MG";
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return createApp({ render: () => h(app, props) })
            .use(plugin)
            .use(ServerTable, vueTablesOptions)
            .mixin({ methods: { route } })
            .mixin({ methods: { trans } })
            .mount(el);
    },
});

Inertia.on("progress", (event) => {
    if (event.detail.progress.percentage) {
        NProgress.set((event.detail.progress.percentage / 100) * 0.9);
    }
});

InertiaProgress.init({ color: "#000" });
